import { useMemo } from 'react'
import { useSubscription } from '@/libs/supabase/hooks/useSubscription'
import { supabaseClient } from '@/configs/supabase'
import { run } from '@/libs/supabase/supabase.interface'
import { filter, orderBy } from 'lodash'

export const useOrderBookStatusOpen = () => {
  const { rows } = useSubscription('OrderBook', undefined, async () => {
    // Fetch only OPEN orders, ordered desc, to avoid PostgREST's default 1000-row
    // limit hiding recent records (which is what caused RightSection to render empty
    // even though /monitor/:n showed an active order with a higher id).
    const { data } = await run(
      supabaseClient
        .from('OrderBook')
        .select('*')
        .eq('status', 'OPEN')
        .order('created_at', { ascending: false })
    )
    return data ?? []
  })

  return useMemo(
    () => orderBy(filter(rows, { status: 'OPEN' }), ['created_at'], ['desc']),
    [rows]
  )
}
